import {
  defaultTheme,
  Provider as SpectrumProvider,
} from '@adobe/react-spectrum';
import { FC, PropsWithChildren } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useIsDarkTheme } from '@utils/theme';

/**
 * Wrapper component that provides the SpectrumProvider with reactive dark theme support.
 * Uses useIsDarkTheme hook to reactively update colorScheme when theme changes.
 *
 * This wraps Adobe Spectrum components and ensures they update their color scheme
 * when the user's theme preference changes (including real-time system theme changes).
 */
export const ReactiveSpectrumProvider: FC<
  PropsWithChildren<{
    id?: string;
    UNSAFE_className?: string;
  }>
> = ({ children, id, UNSAFE_className }) => {
  const isDarkTheme = useIsDarkTheme();
  return (
    <SpectrumProvider
      id={id}
      theme={defaultTheme}
      colorScheme={isDarkTheme ? 'dark' : 'light'}
      UNSAFE_className={UNSAFE_className}
    >
      {children}
    </SpectrumProvider>
  );
};
